import { api } from '@/lib/axios';
import { type Sample } from './sampleSearchService';

export interface UpdateSampleParams {
  sampleDate: string;
  accommodationId: string;
  sampleTypeId: number;
  sampleUserId: number;
  paxLastNight: number;
  occupiedRooms: number;
  specialDate1: string;
  specialDate2: string;
  specialDate3: string;
  specialDate4: string;
  notes: string;
  sampleRecordStatusId: number;
  createdByUserId: number;
  observatoryNotes?: string;
}

export const updateSample = async (sampleId: string, params: UpdateSampleParams): Promise<Sample> => {
  try {
    const { data } = await api.put<Sample>(`/api/samples/${sampleId}`, params);
    return data;
  } catch (error) {
    console.error('Error al actualizar la muestra:', error);
    throw new Error('Error al actualizar la muestra');
  }
}; 